export const LIST_LIMIT = 50
export const FILE_LIST_LIMIT = 15
